import {Injectable} from '@angular/core';
import {
  IPlatformCommandHandler,
  IPlatformToolHandler
} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {PlatformCommand} from '@shared/commands/command-base';
import {MatDialog} from '@angular/material/dialog';
import {UploadFileDialogComponent} from '../component/dialog-components/upload-file-dialog/upload-file-dialog.component';
import {take} from 'rxjs/operators';
import {FileManagerService} from './file-manager.service';
import {FuseSplashScreenService} from '@barebone-fuse-services/splash-screen.service';
import {SnackBarService} from '@core/services/snack-bar.service';
import {FileMetadata} from '@shared/models/file-model';
import {UploadFileIndex} from '@features/file-manager/file-manager-config';
import {DialogModel} from '@shared/models/dialog.model';
import {DialogService} from '@shared/services/dialog-service';

@Injectable({
  providedIn: 'root',
})

export class UploadFileCommandHandler implements IPlatformCommandHandler {
  private overwrite: boolean;
  private forceCheckIn: boolean;
  constructor(protected dialog: MatDialog,
              private fileManagerService: FileManagerService,
              private fuseSplashScreenService: FuseSplashScreenService,
              private snackBarService: SnackBarService,
              private dialogService: DialogService
  ) {
  }

  executeCommand(command: PlatformCommand, handler: IPlatformToolHandler, callback?: any): boolean {
    let driveId = command.fieldValues['DriveId'];
    const parentId = command.fieldValues['ParentId'];
    const relativePath = command.fieldValues['RelativePath'];
    if (relativePath) {
      driveId = relativePath;
    }
    const dialogRef = this.dialog.open(UploadFileDialogComponent, {
      minWidth: '600px',
      maxWidth: '600px',
      data: {
        parentId: parentId,
        driveId: driveId,
      },
      disableClose: true
    });

    dialogRef.afterClosed().pipe(take(1)).subscribe((result: FormData) => {
      console.log('FormData', result);
      if (result) {
        this.fuseSplashScreenService.show();
        this.directUpload(driveId, parentId, result, handler);
        // this.uploadThroughServer(result, command, handler);
      }
    });
    return true;
  }

  directUpload(driveId: string, parentId: string, formData: FormData, handler: IPlatformToolHandler, callback?: any) {
    formData.append('overwrite', this.overwrite ? 'true' : 'false');
    formData.append('forceCheckIn', this.forceCheckIn ? 'true' : 'false');
    const fileMetaData = new FileMetadata();
    fileMetaData.fileName = formData.get('fileName').toString();
    fileMetaData.driveId = driveId;
    fileMetaData.parentId = parentId;
    fileMetaData.publishEvent = false;
    fileMetaData.overwrite = this.overwrite;
    fileMetaData.forceCheckIn = this.forceCheckIn;

    const file = formData.get('file') as File;
    this.fileManagerService.directUploadInS3(fileMetaData, formData, UploadFileIndex.Client).pipe(take(1)).subscribe(res => {
      console.log('Direct Upload', res);
      this.fuseSplashScreenService.hide();
      const command = res['directUploadSuccessCommand'];
      command.fieldValues['FileSize'] = file.size;
      handler.executeCommand(command, callback);
      this.overwrite = this.forceCheckIn = false;
    }, (error: string) => {
      this.fuseSplashScreenService.hide();
      /*this.snackBarService.showError(error);*/
      console.log('Error', error);
      const re = /already exists/;
      if (re.test(error) && !this.overwrite && !this.forceCheckIn) {
        this.showUploadOptionsDialog(error, driveId, parentId, formData, handler);
      }
      if (this.overwrite || this.forceCheckIn) {
        this.directUpload(driveId, parentId, formData, handler);
      }
      if (!re.test(error)) {
        this.overwrite = this.forceCheckIn = false;
      }
    });
  }

  private showUploadOptionsDialog(error: string, driveId: string, parentId: string, formData: FormData, handler: IPlatformToolHandler) {
    const dialogModel = DialogModel.create('Upload Options', 'UploadOptionsDialogComponent', {error});
    dialogModel.okCaption = 'Upload';
    this.dialogService.showOkCancelDialog(dialogModel).pipe(take(1)).subscribe(state => {
      if (state && state.action === 'OK') {
        const {option} = state.data.input;
        switch (option.id) {
          case 'replace-existing-file':
            this.overwrite = true;
            this.directUpload(driveId, parentId, formData, handler);
            break;
          case 'keep-both-files':
            this.forceCheckIn = true;
            this.directUpload(driveId, parentId, formData, handler);
            break;
          default:
            this.overwrite = this.forceCheckIn = false;
            break;
        }
      }
    });
  }

  private uploadThroughServer(result: FormData, command: PlatformCommand, handler: IPlatformToolHandler) {
    this.fileManagerService.uploadFileWithParentId(result, 'VirtualClientDirectoryEntry')
      .pipe(take(1))
      .subscribe(state2 => {
          this.fuseSplashScreenService.hide();
          command.fieldValues['DirectoryEntryId'] = state2;
          handler.executeCommand(command);
          console.log('State 2', state2);
          handler.invalidateSubject.invalidate();
        },
        (error: string) => {
          const file = result.get('file') as File;
          if (file && file.size > 100000000) {
            this.fuseSplashScreenService.hide();
            this.snackBarService.showError('Upload file size limit exceeded. Please upload a file less then 100 MB');
          } else {
            this.fuseSplashScreenService.hide();
            this.snackBarService.showError(error);
            console.log('Error', error);
          }
        });
  }
}
